import { z } from "zod";

// ==================
// Login Request
// ==================

/**
 * Request body for POST /api/v2/auth/login
 */
export const LoginRequestSchema = z.object({
  email: z.email(),
  password: z.string().min(1),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;

// ==================
// Register Request
// ==================

/**
 * Request body for POST /api/v2/auth/register
 */
export const RegisterRequestSchema = z.object({
  email: z.email(),
  password: z.string().min(8),
  first_name: z.string().min(1),
  last_name: z.string().min(1),
  company_name: z.string().min(1),
  company_website: z.string().optional(),
});

export type RegisterRequest = z.infer<typeof RegisterRequestSchema>;

// ==================
// Forgot Password Request
// ==================

/**
 * Request body for POST /api/v2/auth/forgot-password
 */
export const ForgotPasswordRequestSchema = z.object({
  email: z.email(),
});

export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;

// ==================
// Reset Password Request
// ==================

/**
 * Request body for POST /api/v2/auth/reset-password
 */
export const ResetPasswordRequestSchema = z.object({
  email: z.email(),
  token: z.string().min(1),
  password: z.string().min(8),
  password_confirmation: z.string().min(8),
});

export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;

// ==================
// Verify Email Request
// ==================

/**
 * Request body for POST /api/v2/auth/verify-email
 */
export const VerifyEmailRequestSchema = z.object({
  email: z.email(),
  token: z.string().min(1),
});

export type VerifyEmailRequest = z.infer<typeof VerifyEmailRequestSchema>;

// ==================
// Check Email Request
// ==================

/**
 * Request body for POST /api/v2/auth/check-email
 */
export const CheckEmailRequestSchema = z.object({
  email: z.email(),
});

export type CheckEmailRequest = z.infer<typeof CheckEmailRequestSchema>;
